// The marketing header starts transparent so the page's glow runs up behind it, then fills in
// over the first stretch of scrolling. It lives in the root layout, outside any LiveView, so
// it's a plain listener rather than a hook.
const FILL_DISTANCE = 240;

const header = document.querySelector('[data-scroll-header]');

if (header) {
  let frame = null;

  const update = () => {
    frame = null;
    const fill = Math.min(window.scrollY / FILL_DISTANCE, 1);
    header.style.setProperty('--header-fill', fill.toFixed(3));
  };

  window.addEventListener(
    'scroll',
    () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    },
    { passive: true },
  );

  update();
}
